import { toValue } from 'vue';

/**
 * This function transforms filter parameters into a format suitable for JSON:API requests.
 * It moves all filter-related parameters into a nested `filter` object,
 * converts `perPage` to `per_page`, and joins array values with a pipe (`|`).
 */
export const transformFilters = (initialFilters) => {
    // Top-level keys that should NOT be moved to filter object
    const topLevelKeys = ['page', 'per_page', 'sort', 'sortDir'];

    const result = {
        filter: { ...initialFilters.filter },
    };

    Object.entries(initialFilters).forEach(([key, rawValue]) => {
        let value = toValue(rawValue);

        // Handle perPage -> per_page transformation
        if (key === 'perPage') {
            result.per_page = value;
            return;
        }

        // Keep top-level keys at top level
        if (topLevelKeys.includes(key) || key === 'filter') {
            if (key !== 'filter') {
                result[key] = value;
            }
            return;
        }

        // Skip empty/invalid values
        if (value === undefined || value === null || value === '' || (typeof value === 'number' && isNaN(value))) {
            return;
        }

        // Join arrays with pipe, skip empty arrays
        if (Array.isArray(value)) {
            if (value.length === 0) {
                return;
            }
            value = value.join('|');
        }

        result.filter[key] = value;
    });

    return result;
};
